import { createContext, PropsWithChildren } from 'react';

import { useMediaQuery } from '@oaknorth/component-core-v2';

import { MEDIA_TYPE_TO_BP } from './constants';
import { MediaType } from './types';

export interface MediaContextValue {
  mediaTypeMatches: Record<MediaType, boolean>;
}

export const MediaContext = createContext<MediaContextValue | undefined>(undefined);

const DEFAULT_MEDIA_TYPE_MATCHES: Record<MediaType, boolean> = {
  [MediaType.SMALL_SCREEN]: false,
  [MediaType.MOBILE]: false,
  [MediaType.TABLET]: false,
  [MediaType.LAPTOP]: false,
  [MediaType.DESKTOP]: false,
  [MediaType.LARGE_SCREEN]: false,
};

export function MediaContextProvider({ children }: PropsWithChildren<{}>) {
  const mediaTypeQueryResults = useMediaQuery(
    // eslint-disable-next-line @oaknorth/ui/no-template-literals -- media query not user facing
    Object.values(MediaType).map((mediaType) => `(min-width: ${MEDIA_TYPE_TO_BP[mediaType]})`),
    { fallback: [] }
  );

  const mediaTypeMatches = Object.values(MediaType).reduce<Record<MediaType, boolean>>(
    (acc, currentMediaType, index) => {
      return { ...acc, [currentMediaType]: mediaTypeQueryResults[index] };
    },
    DEFAULT_MEDIA_TYPE_MATCHES
  );

  return (
    <MediaContext.Provider
      value={{
        mediaTypeMatches,
      }}
    >
      {children}
    </MediaContext.Provider>
  );
}
